import React from 'react';
import MaskedInput from 'react-text-mask';

export default function UniqueRegisterNumberInput(props) {
//   const mask = /\d/.repeat(9);
// console.log(mask);

  return <MaskedInput mask={[/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]} placeholder="" {...props} />;
}
